import { PropTypes } from 'prop-types'

import { Tag } from '@chakra-ui/react'

export const TagSearchItem = ({ tag, url }) => {
  return (
    <Tag variant="outline" color="label.primary" borderColor="label.tertiary" borderRadius="2xl" fontSize="2xs" px={3} py={2} as="a" href={url}>
      {tag}
    </Tag>
  )
}

TagSearchItem.propTypes = {
  tag: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}
